import toQueryString from '../toQueryString';
import sAction from 'sAction';

/**
 * @param {string} view view for url
 * @param {string} module module for url
 * @param {string} record specific record for url
 * @param {object} params extra params to add to the url as query string
 * @return {string} assembled url
 */
export default function assembleURLHash(view, module = null, record = null, params = null) {
    if (!view) {
        return '#home';
    }

    let url = `#${view}`;
    if (module) url += `/${sAction.moduleURLMap[module] || module}`;
    if (record) url += `/${record}`;
    if (params) url += `?${toQueryString(params)}`;

    return url;
}
